import React, { useState } from 'react'
import type { Partner } from '../../context/PartnerAuthContext'

interface PartnerContactCardProps {
  partner: Partner
  accentColor: string
}

/**
 * Carte "Coordonnées" — adresse, site web, contact, boutons copier/ouvrir.
 */
const PartnerContactCard: React.FC<PartnerContactCardProps> = ({ partner, accentColor }) => {
  const [copied, setCopied] = useState(false)

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(partner.address)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Fallback silencieux
    }
  }

  const infoItem = (label: string, value: string | null | undefined) => {
    if (!value) return null
    return (
      <div style={{ marginBottom: '0.75rem' }}>
        <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
          {label}
        </p>
        <p style={{ margin: '0.15rem 0 0 0', fontWeight: '500', color: '#1e293b', fontSize: '0.95rem' }}>
          {value}
        </p>
      </div>
    )
  }

  const btnStyle: React.CSSProperties = {
    padding: '0.4rem 0.75rem',
    borderRadius: '0.375rem',
    border: `1px solid ${accentColor}`,
    background: 'transparent',
    color: accentColor,
    cursor: 'pointer',
    fontSize: '0.82rem',
    fontWeight: '500',
    transition: 'all 0.2s',
  }

  return (
    <div
      data-testid="contact-card"
      style={{
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '0.75rem',
        padding: '1.5rem',
      }}
    >
      <h3 style={{ margin: '0 0 1rem 0', fontSize: '1.1rem', fontWeight: '600', color: '#1e293b' }}>
        📍 Coordonnées
      </h3>

      {infoItem('Adresse', partner.address)}
      {infoItem('Contact', partner.contact_name)}
      {infoItem('Email', partner.contact_email)}
      {infoItem('Téléphone', partner.contact_phone)}
      {infoItem('Site web', partner.website_url)}

      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem', flexWrap: 'wrap' }}>
        <button data-testid="copy-address-button" onClick={handleCopyAddress} style={btnStyle}>
          {copied ? '✓ Copié !' : '📋 Copier l\'adresse'}
        </button>
        {partner.website_url && (
          <a
            href={partner.website_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="open-website-button"
            style={{ ...btnStyle, textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
          >
            🌐 Ouvrir le site
          </a>
        )}
      </div>
    </div>
  )
}

export default PartnerContactCard
